import classNames from 'classnames';
import { gsap } from 'gsap';
import { memo, useLayoutEffect, useRef } from 'react';

import Fade from '@mui/material/Fade';

import { faPause, faPlay, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',

  '.OA-wrapper': {
    width: '40%',
    height: 0,
    paddingTop: '40%',
    position: 'relative',
    transform: 'translateY(-20px)',
  },
  '.OA-wrapperInner': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.OA-background': {
    width: '60%',
    height: '60%',
    maxHeight: 120,
    maxWidth: 120,
    opacity: 0,
    backgroundColor: palette.grey[600],
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.OA-background_static': { opacity: 0.4 },
  '&:hover .OA-background_static': { opacity: 0.6 },
  '.OA-background_loader': { opacity: 0.5 },
  '.OA-icon': {
    color: palette.grey[300],
    width: '50% !important',
    height: '50% !important',
  },
});

export default memo(function OverlayActions({ hasStarted, loading, playing }) {
  const playingRef = useRef(null);

  const fixed = !loading && !hasStarted && !playing;

  const prevPlaying = useRef(playing);
  useLayoutEffect(() => {
    if (prevPlaying.current !== playing) {
      gsap.fromTo(playingRef.current, 0.6, { autoAlpha: 0.6, scale: 0 }, { autoAlpha: 0, scale: 1 });
    }
    prevPlaying.current = playing;
  }, [playing]);

  return (
    <div css={rootCss} onContextMenu={e => e.preventDefault()}>
      <div className="OA-wrapper">
        <div className="OA-wrapperInner">
          <div className={classNames('OA-background', { 'OA-background_static': fixed })} ref={playingRef}>
            <FontAwesomeIcon className="OA-icon" icon={fixed || playing ? faPlay : faPause} />
          </div>
        </div>
        <Fade appear={false} enter={false} in={loading} timeout={600}>
          <div className="OA-wrapperInner">
            <div className={classNames('OA-background', 'OA-background_loader')}>
              <FontAwesomeIcon className="OA-icon" icon={faSpinner} pulse />
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
});
